import React from "react";
import Download from "../../components/Download";
class ListaGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.onToggle = this.onToggle.bind(this);
  }
  onToggle(event) {
    this.setState({ open: !this.state.open });
  }
  render() {
    if (this.props.items && this.props.items.length > 0) {
      let info=this.props.info ||{};
      let ambito=this.props.ambito || '';
      return (
        <div className="ml-1 mr-1 mt-1 charts-container-section">
          <div className="text-center">
            <span>Descargar</span>
            <span className="ml-2 text-primary text-center">
              <Download ambito={ambito} info={info} datos={this.props.items} />
            </span>
          </div>
          <table className="table table-sm mt-1">
            <thead>
              <tr>
                <th scope="col" className="text-center text-primary">
                  Periodo
                </th>
                <th scope="col" className="text-right text-primary">
                  {info.unidad} ({info.unidad_sigla})
                </th>
                <th scope="col">
                <div className="ml-4"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.items.map((item, key) => {
                return (
                  <tr key={key}>
                    <td className="text-secondary text-center">{item.periodo}</td>
                    <td className="text-secondary text-right">{item.valor}</td>
                    <td >
                      <div className="ml-4"></div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default ListaGrid;
